// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"xq-z","imageAndVideoCount":"yq-z","imageAndVideoContainer":"zq-z","viewAllReviews":"Aq-z"};